import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { HeaderComponent } from './header/header.component';
import { HomeRedirectComponent } from './home-redirect/home-redirect.component';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { SidebarComponent } from './sidebar/sidebar.component';

@NgModule({
  declarations: [MainLayoutComponent, HeaderComponent, SidebarComponent, HomeRedirectComponent],
  imports: [CommonModule, RouterModule, SharedModule],
  exports: [MainLayoutComponent, HomeRedirectComponent]
})
export class LayoutModule {}
